<template>
  <div class="dashboard-balance">
    <h3 class="dashboard-h3">{{ $t("components.dashboard.balance.title") }}</h3>

    <div
      class="dashboard-balance__balance"
      :class="{ 'dashboard-balance__balance__smaller': user.balance > 999 }"
    >
      {{ user.balance | currency }}
    </div>

    <div class="dashboard-balance__buttons">
      <div
        v-b-tooltip="
          !hasApprovedCommunity
            ? $t('components.dashboard.balance.approval_required_tooltip')
            : null
        "
        class="d-inline-block"
      >
        <icon-button
          v-b-modal.add-credit-modal
          class="mr-2"
          size="sm"
          variant="outline-success"
          :disabled="!hasApprovedCommunity"
        >
          {{ $t("components.dashboard.balance.provision") | capitalize }}
        </icon-button>
      </div>

      <div class="d-inline-block">
        <icon-button
          v-b-modal.claim-modal
          :disabled="user.balance < 10"
          size="sm"
          variant="ghost-secondary"
          :loading="claiming"
        >
          {{ $t("components.dashboard.balance.claim") | capitalize }}
        </icon-button>
      </div>
    </div>

    <p v-if="user.balance < 10" class="small text-muted">
      {{ $t("components.dashboard.balance.minimum_balance") }}
    </p>

    <b-modal
      id="add-credit-modal"
      :title="$t('components.dashboard.balance.provision_modal_title')"
      size="lg"
      footer-class="d-none"
    >
      <user-add-credit-box
        :payment-methods="user.payment_methods"
        :add-standard-options="true"
        @bought="closeModal"
        @cancel="closeModal"
      />
    </b-modal>

    <b-modal
      id="claim-modal"
      :title="$t('components.dashboard.balance.claim_modal_title')"
      size="lg"
      hide-footer
    >
      <user-claim-credits-box :user="user" @claimed="closeModal" @cancel="closeModal" />
    </b-modal>
  </div>
</template>

<script>
import { currency } from "@/helpers/filters";
import IconButton from "@/components/shared/IconButton.vue";
import UserAddCreditBox from "@/components/User/AddCreditBox.vue";
import UserClaimCreditsBox from "@/components/User/ClaimCreditsBox.vue";
import { userIsApproved } from "@/helpers/permissions/users";

export default {
  name: "DashboardBalance",
  components: {
    IconButton,
    UserAddCreditBox,
    UserClaimCreditsBox,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasApprovedCommunity() {
      return userIsApproved(this.user);
    },
    claiming() {
      return this.$store.state.account.claiming;
    },
  },
  methods: {
    currency,
    closeModal() {
      this.$bvModal.hide("add-credit-modal");
      this.$bvModal.hide("claim-modal");
    },
  },
};
</script>

<style lang="scss">
.dashboard-balance {
  .btn {
    margin-left: 0;
    margin-bottom: 10px;
  }

  h3.dashboard-h3 {
    margin: 0;
  }
  &__balance {
    font-size: 3rem;
    margin-bottom: 0.5rem;
    font-weight: bold;
    color: $primary;

    &__smaller {
      font-size: 2rem;
      margin: 0.5rem 0 1rem;
    }
  }

  &__buttons {
    margin-bottom: 10px;
  }
}
</style>
